import { put, takeLatest } from 'redux-saga/effects';
import { LogLicenze } from '../../reducers/r_index';

import authService from '../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { codiceUtente } }) {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/Log/GetLogOperations/' + codiceUtente, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const requestResult = yield response.json();

        //creo l'array del log delle licenze
        var log_licenze = requestResult;

        yield put(LogLicenze.creators.getLogLicenzeSuccess({ log_licenze }));

    } catch (e) {
        yield put(LogLicenze.creators.getLogLicenzeFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(LogLicenze.types.GET_LOG_LICENZE_REQUEST, runAction);
}



/* esempio risposta
var log_licenze = [
      {
        ID: '5',
        ProductKey: '0IH3U-U8RZ5-K8DT8-MVSWC',
        DataOperation: '2020-02-21T15:43:00+01:00',
        DesOperation: 'Inserito CodiceModuli',
        CodiceUtente: 'CODICEADMIN',
        SerialNumber: '53455'
      },
      {
        ID: '4',
        ProductKey: 'ILQ31-1S3S6-ZVFMU-5DEDP',
        DataOperation: '2020-02-21T14:53:00+01:00',
        DesOperation: 'Licenza bloccata',
        CodiceUtente: 'CODICEADMIN',
        SerialNumber: '190002'
      },
      {
        ID: '3',
        ProductKey: '0IH3U-U8RZ5-K8DT8-MVSWC',
        DataOperation: '2020-02-21T11:54:00+01:00',
        DesOperation: 'Data Scadenza Modificata: 2021-06-30',
        CodiceUtente: 'CODICEADMIN',
        SerialNumber: '53455'
      },
      {
        ID: '1',
        ProductKey: 'KAC49-9RQV0-RUNW4-X27YJ',
        DataOperation: '2020-02-21T11:48:00+01:00',
        DesOperation: 'Inserita Licenza - Tipologia: Enterprise; PK: KAC49-9RQV0-RUNW4-X27YJ; SN: 200589',
        CodiceUtente: 'UTENTEPROVA',
        SerialNumber: '200589'
      },
      {
        ID: '2',
        ProductKey: 'KAC49-9RQV0-RUNW4-X27YJ',
        DataOperation: '2020-02-21T11:48:00+01:00',
        DesOperation: 'Aggiunta configurazione moduli con data decorrenza: 21/02/2020',
        CodiceUtente: 'UTENTEPROVA',
        SerialNumber: '200589'
      }
    ];


*/